import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D424 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D424 - Software Engineering Capstone</h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 13.67 hrs</h4>
        <hr />
        <div className="card-body">
          <p>Looks like we’re here, eh? Almost at the finish line! 🎉</p>
          <p>
            I put in about 14 hours for this course. It took me 3 weeks, but
            mostly because I was just waiting for tasks to be evaluated.
          </p>
          <p>
            Breakdown of Tasks:
            <ul>
              <li>
                Task 1: Super easy. Fill out the instructor’s form (she’ll
                send it over email). Once she signs it, attach it, fill out a
                few other things, and submit.
              </li>
              <li>
                Task 2: Writing an extensive report (just grind through it).
              </li>
              <li>
                Task 3: Creating the user manual—this took me the longest. Pro
                tip: If you're using a mobile app for this course, deployment is
                as simple as hosting a static webpage (Netlify, Firebase, GitHub
                Pages, etc.) with a download link for your APK. Deploy your app
                before finishing Task 3—it makes writing the user manual much
                easier.
              </li>
              <li>
                Task 4: Just record a video showing how you deployed your
                application. That’s it.
              </li>
            </ul>
          </p>
          <p>
            If anyone needs help with Firebase deployment, here’s my video
            explaining it in a simplified way: 🎥{" "}
            <a href="https://wgu.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=4ccfd45f-8d83-4de8-9c1b-b27300002811" target="_blank" rel="noreferrer">
              Firebase Deployment Guide
            </a>
          </p>
          <h5>Good luck and happy graduating! We finally made it! 🎓🚀</h5>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default D424;
